<template>
  <div class="navbar-container">
    <div v-for="section in sectionsToShow" class="section" :key="section.name">
      <div class="section-title">
        {{ $t(section.titleKey) }}
      </div>
      <ul class="section-item-list">
        <li
          v-bind:key="item.titleKey"
          v-for="item in section.items.filter(item => item.isVisible())"
          :class="['section-item']"
          @click="item.handler ? item.handler() : null"
        >
          <div class="section-item-icons">
            <span class="card-icon" :style="item.style" />
          </div>
          <div class="section-item-details">
            <div class="section-item-title">{{ $t(item.titleKey) }}</div>
            <div class="section-item-subtitle">{{ $t(item.subtitleKey) }}</div>
          </div>
          <div class="section-item-icons">
            <span class="card-icon external-link-icon" v-if="isExternalLink(item)" />
            <span class="success-badge" v-else-if="hasVerifiedBadge(item)">
              {{ $t("domainActivation.statusBar.status.verified") }}
            </span>
            <span class="pending-badge" v-else-if="hasPendingBadge(item)">
              {{ $t("domainActivation.statusBar.status.pending") }}
            </span>
            <CaretIcon v-else v-show="!item.hideRedirectIcon" class="caret-icon" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CaretIcon from "../../assets/caret.svg?inline";
import { MOBILE_NAV_MENU_TYPE } from "@/const/mobile-nav-bar-constant";

export default {
  props: {
    sections: {
      type: Array,
      default: [],
    },
  },
  computed: {
    sectionsToShow() {
      return this.sections.filter(section => section.items.some(item => item.isVisible()));
    },
  },
  components: {
    CaretIcon,
  },
  methods: {
    hasVerifiedBadge(item) {
      return item?.right?.type === MOBILE_NAV_MENU_TYPE.VERIFIED_BADGE;
    },
    hasPendingBadge(item) {
      return item?.right?.type === MOBILE_NAV_MENU_TYPE.PENDING_BADGE;
    },
    isExternalLink(item) {
      return item?.right?.type === MOBILE_NAV_MENU_TYPE.EXT_LINK;
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar-container {
  padding: 16px 0;
  background-color: var(--mobile-nav-bg);
}

.section {
  margin-top: 20px;

  &:not(:first-of-type) {
    margin-top: 40px;
  }

  .section-title {
    font-weight: 500;
    font-size: 12px;
    margin-bottom: 4px;
    color: var(--primaryTextCol);
  }

  .section-subtitle {
    font-size: 14px;
    margin: -4px 0 8px;
    font-weight: normal;
    line-height: 20px;
    color: var(--tertiaryTextCol);
  }

  // more features section
  &:last-of-type {
    .section-item {
      flex-direction: column;
      gap: 8px;
      align-items: flex-start;

      .section-item-title {
        color: var(--primaryBtnCol);
      }

      .section-item-icons {
        .card-icon {
          width: 45px;
          background-size: 38px;
        }
      }
    }
  }
}

.section-item-list {
  list-style: none;
  margin-inline-start: 0;
  padding-inline-start: 0;
  border: 1px solid var(--white);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;

  li {
    background-color: var(--white);
  }
}

.section-item {
  padding: 12px;
  cursor: pointer;
  background-color: var(--primaryBgCol);
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;

  &:not(:last-of-type) {
    border-bottom: 1px solid var(--lineSepaCol);
  }

  .section-item-title {
    font-size: 15px;
    font-weight: 500;
    line-height: 150%;
  }

  .section-item-subtitle {
    color: var(--tertiaryTextCol);
  }

  .section-item-details {
    width: 100%;
  }

  .section-item-icons {
    display: flex;
    align-items: center;
  }

  .caret-icon {
    width: 28px;
    height: 28px;
    color: var(--iconColor2);
    transform: rotate(-90deg);
  }

  .success-badge,
  .pending-badge {
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 1px 6px;
    white-space: nowrap;
  }

  .success-badge {
    color: var(--dnsRecordsActive);
    border-radius: 4px;
    border: 1px solid var(--dnsRecordsActive);
    background: var(--mobileNavBarSuccessBadgeBg);
  }

  .pending-badge {
    color: var(--primaryTextCol);
    border-radius: 4px;
    border: 1px solid var(--mobileNavBarPendingBadgeBg);
    background: var(--mobileNavBarPendingBadgeBg);
  }

  .card-icon {
    width: 32px;
    aspect-ratio: 1;
    display: inline-block;
    background: url("../../assets/mobile/mobile-nav-sprite.svg") center 0 no-repeat;
    background-size: 30px;
    background-position-x: center;

    &.external-link-icon {
      background: url("../../assets/external-link-icon.svg") center no-repeat;
      width: 24px;
      background-size: 24px;
    }
  }
}
</style>
